import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Reveal from "./Reveal";
import QuoteForm from "./QuoteForm";
import { CONTACT, BUSINESS_HOURS } from "./data";

const MAP_SRC = "https://www.google.com/maps?q=Round+Rock,+Texas&z=9&output=embed";

export default function Contact() {
  return (
    <section id="contact" className="relative bg-[#101317] grain py-24 md:py-32">
      <div className="relative z-10 max-w-[1200px] mx-auto px-5 lg:px-10">
        <Reveal>
          <div className="flex items-center gap-3 mb-4">
            <img src="/markonlyvector.png" alt="" className="h-6 w-auto opacity-80" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#9AA3AF]">Contact</span>
          </div>
          <h2 className="text-3xl md:text-5xl text-[#C9A44C] max-w-3xl">
            Request service or get a straight answer.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Left: form */}
          <Reveal>
            <div className="rounded-3xl bg-[#171B22] border border-[#9AA3AF]/15 p-7 md:p-9">
              <h3 className="text-2xl text-white mb-6">Request a Quote</h3>
              <QuoteForm idPrefix="contact-quote" />
            </div>
          </Reveal>

          {/* Right: details + map */}
          <Reveal delay={0.1}>
            <div className="space-y-6">
              <a
                data-testid="click-to-call"
                href={CONTACT.phoneHref}
                className="group block rounded-3xl bg-gradient-to-br from-[#171B22] to-[#101317] border border-[#C9A44C]/30 p-8 hover:border-[#C9A44C] transition-colors duration-300"
              >
                <div className="flex items-center gap-3 text-[#9AA3AF] text-xs tracking-[0.25em] uppercase mb-3">
                  <Phone size={16} /> Call us now
                </div>
                <div className="text-4xl md:text-5xl text-[#C9A44C] group-hover:text-[#D6B15A] transition-colors duration-300">
                  {CONTACT.phone}
                </div>
              </a>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <a
                  data-testid="email-link"
                  href={CONTACT.emailHref}
                  className="rounded-2xl bg-[#171B22] border border-[#9AA3AF]/15 p-6 hover:border-[#C9A44C]/40 transition-colors duration-300 block"
                >
                  <Mail className="text-[#005EA8] mb-3" size={22} />
                  <div className="text-xs tracking-[0.2em] uppercase text-[#9AA3AF] mb-1">Email</div>
                  <div className="text-white break-all">{CONTACT.email}</div>
                </a>
                <div className="rounded-2xl bg-[#171B22] border border-[#9AA3AF]/15 p-6">
                  <Clock className="text-[#C9A44C] mb-3" size={22} />
                  <div className="text-xs tracking-[0.2em] uppercase text-[#9AA3AF] mb-1">Hours</div>
                  <div className="text-white">{BUSINESS_HOURS}</div>
                </div>
              </div>

              <div className="rounded-2xl bg-[#171B22] border border-[#9AA3AF]/15 p-6">
                <div className="flex items-start gap-3">
                  <MapPin className="text-[#C3262E] shrink-0 mt-0.5" size={22} />
                  <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-[#9AA3AF] mb-1">Service Area</div>
                    <div className="text-white leading-relaxed">{CONTACT.serviceArea}</div>
                  </div>
                </div>
              </div>

              <div className="rounded-3xl overflow-hidden border border-[#9AA3AF]/15 relative">
                <iframe
                  data-testid="google-map"
                  title="Million-Air service area centered on Round Rock, TX"
                  src={MAP_SRC}
                  className="w-full h-[300px] grayscale-[0.2]"
                  style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg) contrast(0.9)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
                <div className="absolute bottom-0 inset-x-0 bg-[#101317]/90 px-5 py-3 text-sm text-[#9AA3AF] border-t border-[#9AA3AF]/15">
                  Centered on Round Rock, TX, covering a 50-mile service radius.
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
